import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { IFrostMeasurementStation } from 'src/app/interfaces/IFrostMeasurementStation';

@Injectable({ providedIn: 'root' })

export class olMapEventService {
    invokeMapSelection = new EventEmitter();
    invokeFeaturesupdate = new EventEmitter();
    subsVar: Subscription;
    updatesubsVar: Subscription;
    constructor() { }

    onmapSelection(maetpunktId:number) {
        this.invokeMapSelection.emit(maetpunktId);
    }
     onFeaturesupdate(frostmeasurementStations:IFrostMeasurementStation[] ){
         this.invokeFeaturesupdate.emit(frostmeasurementStations);
     }
}
